import { createContext } from "react";

import type { CalendarContextValue } from "./CalendarContextValue";

export const CalendarContext = createContext<CalendarContextValue | null>(null);

CalendarContext.displayName = "CalendarContext";
